
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Header } from 'components/common/Header';
import { Input } from 'components/common/Input';
import { Separator } from 'components/common/Separator';
import { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import Head from 'next/head';
const InstantSearch = dynamic(() => import('components/common/InstantSearch').then(m => m.InstantSearch), { ssr: false });
const List = dynamic(() => import('components/sell/List').then(m => m.List), {
    ssr: false
});
const SellPage = () => {
    const { t } = useTranslation('common');
    return (<>
      <Head>
        <title>FairArt - {t('sell')}</title>
      </Head>

      <div>
        <Header actions={{ state: 'faq-sell' }}/>

        <Separator />

        <InstantSearch>
          <main className='flex min-h-screen justify-center bg-warm-50 sm:p-6 md:p-8'>
            <section className='flex h-max w-full max-w-[640px] flex-col rounded-xl border border-cool-300 bg-cool-50 px-6 py-4'>
              <h1 className='font-body text-xl font-normal tracking-normal'>
                {t('sell:choose_a_product')}
              </h1>
              <h2 className='font-body text-sm font-normal tracking-normal text-cool-600'>
                {t('sell:search_for_the_product')}
              </h2>

              <Input type='algolia-search' className='mt-6 w-full' inputClassName='bg-warm-50' placeholder={t('cta_search')} size='lg' pill/>

              <List />
            </section>
          </main>
        </InstantSearch>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async () => {
    return { props: {} };
};
export default SellPage;

    async function __Next_Translate__getStaticProps__19cd74a8273__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sell',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19cd74a8273__ as getStaticProps }
  